import { getAnalyticsClient } from 'services/apollo';
import { GetUserQuery } from 'services/apollo/queries';

export const getDataForSettingIdentity = getAnalyticsClient().then((client) =>
  client.query({
    query: GetUserQuery,
    fetchPolicy: 'cache-first',
  })
);
